
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Login from "../pages/login/page";
import Logout from "../pages/logout/page";
import CRM from "../pages/crm/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/logout",
    element: <Logout />,
  },
  {
    path: "/crm",
    element: <CRM />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
